import { render, staticRenderFns } from "./OFFormCheckbox.vue?vue&type=template&id=4de1034a&scoped=true"
import script from "./OFFormCheckbox.vue?vue&type=script&lang=js"
export * from "./OFFormCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de1034a",
  null
  
)

export default component.exports